import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoginComponent} from './login.component';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {UsernamePasswordComponent} from "./username-password/username-password.component";
import {Level2OtpGeneratorChoiceComponent} from "./level2-otp-generator-choice/level2-otp-generator-choice.component";
import {OtpInputComponent} from "./otp-input/otp-input.component";



@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    NzSpinModule,
    NzLayoutModule,
    NzFormModule,
    NzDividerModule,
    UsernamePasswordComponent,
    Level2OtpGeneratorChoiceComponent,
    OtpInputComponent
  ]
})
export class LoginModule { }
